import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { colours, icons } from '../../../Data/Tags';
import { classNames } from '../../../Services/helpers';
import Icon from '../../Icons/Icon';

const TagIcon = ({label, name, help, onChange, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    const colour = colours[formData.colour ?? 'Gray'];

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const changeVal = (val) => {
        updateField(name, val);
        onChange && onChange(val);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <fieldset>
            <legend className="sr-only">{label}</legend>
            <div className="grid grid-cols-6">
                {Object.values(icons).map((icon) => {
                    return <div key={icon}
                        className={classNames(
                        'mx-auto rounded-lg cursor-pointer border',
                        value === icon ? `${colour.border} ${colour.bgLight}` : 'border-transparent opacity-50'
                        )}
                        onClick={() => changeVal(icon)}
                    >
                        <div className={classNames('p-2 pb-1', colour.fill)}>
                            <Icon icon={icon} size="2x" theme={value === icon ? 'solid' : 'light'} />
                        </div>
                    </div>
                })}
            </div>
        </fieldset>

    </CommonFieldWrapper>
}


export default TagIcon;
